import React, { useState } from 'react'
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import InputHeader from './InputHeader'
import {api} from 'lib'

const GooglePre = () => {

  const preApFormItems = [
    {
      name: "Invoice",
      id: "data",
      type: "text",
      placeholder: "4118632168",
      tooltip: "Enter the Invoice ID from Google Console"
    },
    {
      name: "Date",
      id: "date",
      type: "text",
      placeholder: "202204",
      tooltip: "Enter the Invoice Date and Month"
    }
  ]
  
  const initialFormData = {
    data: null
  }

  const [formData, setFormData] = useState(initialFormData);

  const onChange = (e) => {
    let currentFormData = formData;
    currentFormData[e.target.id] = e.target.value;
    setFormData(currentFormData);
  }

  const onSubmit = () => {
    var data = {
      cloud_bill: formData
    };
    console.log(data);
    api.post("/cloud_bills/process_google_invoice", data)
      .then(resp => {
        alert("Your new data has been submitted!")
      })
      .catch(err => {
        alert("There was a problem submitting this workbook. Please try again.")
        console.error("API Error: ", err)
      })
  }

  return (
    <div>
      <h3>Processing the Google Invoice</h3>
      <p>This section will allow you to input an Invoice ID and a date from Google and you will be given the PRE AP
        CSV which will be required in the next step.</p>
      <br />
      <Form>
        {
          preApFormItems && preApFormItems.map((obj, i) => {
            if (obj.type === "text") {
              return (
                <FormGroup key={i}>
                  <Label for={obj.id}>
                    <InputHeader
                      id={obj.id}
                      inputText={obj.name}
                      tooltipText={obj.tooltip}
                    />
                  </Label>
                  <Input
                    type={obj.type}
                    name={obj.name}
                    id={obj.id}
                    onChange={onChange}
                    placeholder={obj.placeholder}
                  />
                </FormGroup>
              )
            } else {
              return null;
            }
          })
        }
        <Button onClick={onSubmit}>Submit</Button>
      </Form>
    </div>
  )
}

export default GooglePre